import permissions from "@/acl/permissions";

export default {
    root: permissions.admin,
    AssessoriaTecnica: permissions.vns_monitor_tipo_complete
        .concat(
            permissions.vns_exam_monitors,
            permissions.container_support,
            permissions.tuevs_complete_crud,
            permissions.dexpara
        ),
    VAMDrive: permissions.vns_monitor_tipo_drive,
    Cliente: permissions.vns_exam_monitors
        .concat(
            permissions.vns_monitor_tipo_cliente,
            permissions.review_observation
        ),
}